import React from 'react'
import { Form, Input, Button, Card, Checkbox } from 'antd'
import PropTypes from 'prop-types'

function validateUrl (url, allowRelative = false) {
  try {
    const _ = new URL(url)
    console.log('Valid URL:', _, url)
    return true
  } catch (e) {
    if (allowRelative) {
      // Only accept /path style
      return /^\/[\w\-./]+$/.test(url)
    }
    return false
  }
}

const RedirectCard = ({ redirect: { source, destination, id, type, permanent }, onSubmit }) => {
  const [form] = Form.useForm()
  React.useEffect(() => {
    form.setFieldsValue({ id, source, destination, permanent })
  }, [id, source, destination, permanent, form])
  const handleFinish = (values) => {
    const { source, destination, permanent } = values
    if (!validateUrl(source, true)) {
      form.setFields([
        { name: 'source', errors: ['Invalid source URL. Must be absolute or valid /path relative URL.'] }
      ])
      return
    }
    if (!/^\/[\w\-./]+$/.test(destination) || /^https?:\/\//.test(destination)) {
      form.setFields([
        { name: 'destination', errors: ['Invalid destination URL. Must be a valid relative URL starting with /path.'] }
      ])
      return
    }
    if (onSubmit) onSubmit({ id, source, destination, permanent })
  }

  return (
    <Card>
      <Form form={form} initialValues={{ id, source, destination, permanent: false }} layout="vertical" onFinish={handleFinish}>
        <Form.Item label="ID" name="id">
          <Input disabled />
        </Form.Item>
        <Form.Item label="Source URL" name="source" rules={[{ required: true, message: 'Source URL is required' }]}>
          <Input placeholder="Enter absolute or /path URL" />
        </Form.Item>
        <Form.Item label="Destination URL" name="destination" rules={[{ required: true, message: 'Destination URL is required' }]}>
          <Input placeholder="Enter /path URL" />
        </Form.Item>
        <Form.Item label="Permanent" name="permanent" rules={[{ required: true, message: 'Permanent flag is required' }]} valuePropName="checked">
          <Checkbox>Enable Permanent Redirect</Checkbox>
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" type="primary">{type === 'add' ? 'Add' : 'Update'}</Button>
        </Form.Item>
      </Form>
    </Card>
  )
}

RedirectCard.propTypes = {
  onSubmit: PropTypes.func,
  redirect: PropTypes.shape({
    destination: PropTypes.string,
    id: PropTypes.string,
    source: PropTypes.string,
    type: PropTypes.string,
    permanent: PropTypes.bool
  })
}

export default RedirectCard
